// extracted by mini-css-extract-plugin
export var deleteModal = "_rb-0";